module.exports = __webpack_public_path__ + "media/bundles/ReactHome/components/layout/images/slide3-0104399b885d666aa1ea9b6b492c3084.jpg";